export default "__VITE_ASSET__6a6f6b84__"